@if (isReadOnly) {
<div>
  @if (sortedVouchers.length > 0) {
  <div>
    <div class="cx-applied-coupon-title">
      {{ 'voucher.vouchersApplied' | cxTranslate }}
    </div>
  </div>
  } @for (voucher of sortedVouchers; track voucher) {
  <div class="coupon-summary cx-coupon-card textonly" role="filter">
    <span class="cx-applied-coupon-code">{{ voucher.voucherCode }}</span>
  </div>
  }
</div>
} @else { @if (!showSrp) {
<div class="row applied-coupons-container align-items-start">
  @for (voucher of sortedVouchers; track voucher) {
  <div class="cx-coupon-card-grid mr-2" role="filter">
    <div class="cx-coupon-apply cx-coupon-card cx-coupon-list-wrap border-0">
      <span class="cx-cart-coupon-code">{{ voucher.voucherCode }}</span>
      <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="removeVoucher(voucher.voucherCode, cartId)"
        [disabled]="cartIsLoading"
        [class.disabled]="cartIsLoading"
      >
        <mat-icon class="material-icons-sharp md-12">close</mat-icon>
      </button>
    </div>
  </div>
  }
</div>
} }
